//import moment from "moment";
//import {tickerToGeneralForm} from '../js/main';
//import axios from 'axios';

export default {
    namespaced: true,
    state: () => ({
            sortParameter: null,
            legs: null,
            position: null,
            direction: null,
            source: null,
            minDays: null,
            maxDays: null,
            userConditions: [],
            query: null
        }),
    mutations: {
        setSortParameter: function (state, sortParameter) {
            state.sortParameter = sortParameter;
        },
        setLegs: function (state, legs) {
            state.legs = legs;
        },
        setPosition: function (state, position) {
            state.position = position;
        },
        setDirection: function (state, direction) {
            state.direction = direction;
        },
        setSource: function (state, source) {
            state.source = source;
        },
        setMinDays: function (state, minDays) {
            state.minDays = minDays;
        },
        setMaxDays: function (state, maxDays) {
            state.maxDays = maxDays;
        },
        setUserConditions: function (state, userConditions) {
            state.userConditions = userConditions;
        },
        setQuery: function (state, query) {
            state.query = query;
        }
    }
};


